import axios from "./axiosConfig";
import { API_URL } from "../config";
import {
  Notification,
  NotificationFilters,
  NotificationPayload,
  NotificationTemplate,
  NotificationTemplateStatusPayload,
  NotificationChannelPreferences,
  NotificationTestChannel,
  NotificationTestResult,
} from "../types/Notification";

export const NotificationService = {
  list: async (filters: NotificationFilters = {}): Promise<Notification[]> => {
    const response = await axios.get(`${API_URL}/v1/notifications`, { params: filters });
    return response.data.items;
  },

  listTemplates: async (campaignId?: number): Promise<NotificationTemplate[]> => {
    const response = await axios.get(`${API_URL}/v1/notifications/catalog`, { params: { campaign_id: campaignId } });
    return response.data.items;
  },

  create: async (payload: NotificationPayload): Promise<Notification> => {
    const response = await axios.post(`${API_URL}/v1/notifications`, payload);
    return response.data;
  },

  update: async (id: number, payload: Partial<NotificationPayload>): Promise<Notification> => {
    const response = await axios.put(`${API_URL}/v1/notifications/${id}`, payload);
    return response.data;
  },

  toggleStatus: async (id: number, active: boolean, campaignId?: number): Promise<Notification> => {
    const response = await axios.patch(
      `${API_URL}/v1/notifications/${id}/status`,
      { active, campaign_id: campaignId },
      {
        params: { active, campaign_id: campaignId },
      }
    );
    return response.data;
  },

  setTemplateStatus: async (
    templateId: string,
    payload: NotificationTemplateStatusPayload
  ): Promise<NotificationTemplate> => {
    const response = await axios.patch(`${API_URL}/v1/notifications/catalog/${templateId}/active`, payload);
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await axios.delete(`${API_URL}/v1/notifications/${id}`);
  },

  getChannelPreferences: async (campaignId: number): Promise<NotificationChannelPreferences> => {
    const response = await axios.get(`${API_URL}/v1/notifications/channels`, { params: { campaign_id: campaignId } });
    return response.data;
  },

  setChannelPreferences: async (
    prefs: Pick<NotificationChannelPreferences, "campaign_id" | "email" | "whatsapp">
  ): Promise<NotificationChannelPreferences> => {
    const response = await axios.put(`${API_URL}/v1/notifications/channels`, prefs);
    return response.data;
  },

  sendTest: async (
    campaignId: number,
    templateId?: string,
    channel: NotificationTestChannel = "WHATSAPP"
  ): Promise<NotificationTestResult> => {
    const response = await axios.post(`${API_URL}/v1/notifications/test`, {
      campaign_id: campaignId,
      template_id: templateId,
      channel,
    });
    return response.data;
  },
};
